import { MedicalInformationSignAllAttachmentsCommand } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { CertificateFault, useCertificateFaultHandlerMap } from '~libs.desktop.shared.account';

import { patientMedicalInformationTranslationKeys } from '../../translations';

type MedicalDataAccessAuthorizationUpdateCommandParameters = {
   medicalInformationId: number;
};

type MedicalDataAccessAuthorizationUpdateCommandOptions = {
   onAuthenticationRequired: VoidFunction;
   onMedicalDataAccessAuthorizationUpdate: VoidFunction | undefined;
};

export const useCqrsMedicalDataAccessAuthorizationUpdateCommand = (
   options: MedicalDataAccessAuthorizationUpdateCommandOptions
): UseCqrsCommandResult<void, MedicalDataAccessAuthorizationUpdateCommandParameters, CertificateFault> => {
   return useCqrsCommand(
      (parameters: MedicalDataAccessAuthorizationUpdateCommandParameters) => {
         const command = new MedicalInformationSignAllAttachmentsCommand();
         command.medicalInformationId = parameters.medicalInformationId;
         return command;
      },
      {
         onSuccess: () => {
            options.onMedicalDataAccessAuthorizationUpdate?.();
            dispatchSnackbarPositiveEvent(patientMedicalInformationTranslationKeys.previewModal.haveBeenSigned);
         },
         onFault: {
            ...useCertificateFaultHandlerMap({
               onAuthenticationRequired: options.onAuthenticationRequired,
            }),
         },
      }
   );
};
